import { Button, Icons, useToggle } from '@commenda/kakashi';
import { ConfirmationModal } from '../../../../molecules/modals/ConfirmationModal';
import {
  TaskParty,
  TaskStatus,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus } from '../../../utils';

export const SourceStamPaperTask = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  const { role, mutate } = context;

  const confirmationModalVisibility = useToggle();

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.TO_DO]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Agent procures stamp paper" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="Stamp paper procured"
                timestamp={task.updatedAt}
                status={task.status}
              />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.TO_DO]: {
            actions: (
              <Button
                size="sm"
                onClick={confirmationModalVisibility.show}
                variant="primary"
              >
                <Icons.Check className="size-4" />
                Mark as completed
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Mark update: Procure stamp paper" />
            ),
          },
          [TaskStatus.BACKLOG]: {
            actions: (
              <Button size="sm" disabled variant="primary">
                <Icons.Check className="size-4" />
                Mark as completed
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Mark update: Procure stamp paper" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label=" Stamp paper procured"
                timestamp={task.updatedAt}
                status={task.status}
              />
            ),
          },
        },
      };

      return (
        // Admin viewers run these steps too, and an unmapped role renders no actions.
        stateMap[state.role === TaskParty.ADMIN ? TaskParty.AGENT : state.role]?.[
          state.status
        ] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{ role, status: task.status }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
        displayNumber={displayNumber}
      />
      <ConfirmationModal
        isOpen={confirmationModalVisibility.visible}
        onClose={confirmationModalVisibility.hide}
        onConfirm={async () => {
          await updateTaskStatus({
            task,
            status: TaskStatus.COMPLETED,
            mutate,
          });
          confirmationModalVisibility.hide();
        }}
        title="Mark as completed"
        message="Please note that this action will update the customer. To revert this change, please contact Commenda Support."
        hideCancelButton
      />
    </div>
  );
};
